<template src="./PasswordReset.html"></template>

<script lang="ts">
import { defineComponent } from "vue";
import AuthCard from "@/components/AuthCard";
import GenericPasswordChangeForm from "@/components/GenericPasswordChangeForm";
import BaseDialog from "@/components/BaseDialog";
import { accountModule } from "@/store/modules/account";
import { AccountActions } from "@/store/modules/account/actions";
import { AccountGetters } from "@/store/modules/account/getters";
import { notificationsModule } from "@/store/modules/notifications";
import { NotificationsActions } from "@/store/modules/notifications/actions";
import Errors from "./BackendResponseErrors.json";
import { Routes } from "@/router/routes";

export default defineComponent({
    components: { AuthCard, GenericPasswordChangeForm, BaseDialog },
    computed: {
        ...accountModule.mapGetters({
            loading: AccountGetters.Loading,
            errors: AccountGetters.Errors
        }),
        token(): string {
            return this.$route.query.token as string;
        }
    },
    data() {
        return {
            informationDialog: false
        };
    },
    methods: {
        ...accountModule.mapActions({
            resetPassword: AccountActions.ResetPassword
        }),
        ...notificationsModule.mapActions({
            showError: NotificationsActions.NotifyError
        }),
        async submit(password: string): Promise<void> {
            if (!this.token) {
                this.showError("Missing token.");
                return;
            }
            await this.resetPassword({
                token: this.token,
                newPassword: password
            });
            this.informationDialog = true;
        },
        goToLogin(): void {
            this.$router.push(Routes.Login);
        }
    },
    watch: {
        errors(errors: string[] | null) {
            if (!errors) return;
            if (errors[0].includes(Errors.InvalidToken.Error)) {
                this.showError(Errors.InvalidToken.Message);
            } else if (errors[0].includes(Errors.NetworkError.Error)) {
                this.showError(Errors.NetworkError.Message);
            } else if (errors[0].includes(Errors.BadRequest.Error)) {
                this.showError(Errors.BadRequest.Message);
            } else {
                this.showError(Errors.Default.Message);
            }
        }
    }
});
</script>

<style src="./PasswordReset.scss" lang="scss" scoped></style>
